import React from 'react';
import { useAppSelector } from '../../../../hooks/redux';
import BellLightIcon from '../../../../assets/images/BellLight.png';
import BellDarkIcon from '../../../../assets/images/BellBlack.png';

export const BellIcon = () => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (colorTheme) {
      case 'dark': {
        return BellDarkIcon;
      }
      default: {
        return BellLightIcon;
      }
    }
  };
  return <img src={getIcon(theme)} alt="bell" />;
};
